import type { Quote } from "./types";
import { createQuoteStory } from "./types";

export const cukupDunia: Quote = {
  id: "cukup-dunia-tirmidzi",
  name: "Dunia Sudah Dikumpulkan Untukmu",
  emoji: "🌅",
  category: "Sabar & Tawakkal",
  description:
    "Siapa yang pagi hari dalam keadaan aman, sehat, dan punya makan hari itu — seolah **dunia telah dikumpulkan untuknya**.",
  detail:
    "Hadits ini diriwayatkan oleh Imam Tirmidzi dari sahabat Ubaidullah bin Mihshan al-Anshari radhiyallahu 'anhu. Rasulullah ﷺ mengajarkan bahwa kecukupan sejati hanya butuh tiga hal: **rasa aman, kesehatan, dan makan hari ini**. Siapa yang memiliki ketiganya, dia sudah menggenggam dunia.",
  tldr: "Aman, sehat, dan kenyang hari ini — kamu sudah punya segalanya.",
  story: createQuoteStory("Dunia Sudah Dikumpulkan Untukmu", "🌅", [
    { hook: {
      title: "Kamu merasa hidupmu kurang?",
      body: "Coba jawab tiga pertanyaan ini: Kamu **aman**? Kamu **sehat**? Kamu **sudah makan** hari ini?",
    } },
    { source: {
      body: "Barangsiapa di antara kalian pada waktu pagi dalam keadaan **aman** pada dirinya, **sehat** badannya, dan memiliki **makanan pokok** pada hari itu, maka seolah-olah **dunia telah dikumpulkan untuknya**.",
      title: "HR. Tirmidzi no. 2346",
    } },
    { reveal: {
      body: "Kita sering mengukur kecukupan dari apa yang **belum** kita punya. Padahal Rasulullah ﷺ mendefinisikan kecukupan dari tiga hal yang **sudah ada di depan mata**.",
    } },
    { insight: {
      title: "Tiga hal, itu saja",
      body: "**Aman** → kamu tidak dalam bahaya.\n**Sehat** → tubuhmu berfungsi.\n**Makan hari ini** → kebutuhanmu tercukupi.\n\nTiga hal ini sering kita anggap biasa — padahal bagi jutaan orang, ini adalah doa yang belum terjawab.",
    } },
    { engagement: {
      title: "Sudahkah kamu bersyukur hari ini?",
      body: "Kalau tiga hal itu sudah kamu punya pagi ini — dunia sudah ada di tanganmu. Bukan dunia yang kamu kejar, tapi dunia yang **benar-benar kamu butuhkan**.",
    } },
  ]),
  related: ["urusan-mukmin-muslim", "sabar-baqarah-153"],
};
